import React from 'react'

const LegalBodyDiv = ({ multiply = 0, children }) => {
  return (
    <div style={{ paddingLeft: `${Math.floor(8 * multiply)}px` }}>
      {children}
    </div>
  )
}

export default LegalBodyDiv
